export const nameValidator = (value, minLength = 2, maxLength = 200) => {
  if (value.length < minLength)
    return `Name must be at least ${minLength} characters long`;
  if (value.length > maxLength)
    return `Name must be less than ${maxLength} characters long`;
  return false;
};

export const emailValidator = (value) => {
  if (!/^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]+$/.test(value))
    return 'Invalid email address';
  return false;
};

export const numberValidator = (value) => {
  // Remove commas and whitespace, then check if it's a valid number
  const cleanedValue = String(value).replace(/,/g, '').trim();
  if (cleanedValue === '' || cleanedValue === '-') return false; // Allow empty or just minus sign
  if (isNaN(cleanedValue)) return 'Must be a number';
  return false;
};

export const phoneNumberValidator = (value) => {
  // Soft international check: 6–15 digits after stripping formatting (+, spaces, dashes, etc.).
  // Avoids hard US 10/11 rules so non-US numbers (incl. short local lengths / 011 prefixes) can save.
  const digits = String(value ?? '').replace(/\D/g, '');
  if (digits.length >= 6 && digits.length <= 15) return false;
  return 'Invalid phone number';
};
